import React from 'react';
import { Box, Button } from '@mui/material';
import { useLanguageSwitcher } from '../../hooks/useLanguageSwitcher';

const LANG_LABELS = {
  es: 'ES',
  fr: 'FR',
  en: 'EN',
};

const LanguageSwitcher = ({ variant = 'desktop' }) => {
  const { currentLang, switchLanguage, supportedLangs } = useLanguageSwitcher();

  if (variant === 'mobile') {
    return (
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', py: 1 }}>
        {supportedLangs.map((lng) => (
          <Button
            key={lng}
            size="small"
            onClick={() => switchLanguage(lng)}
            sx={{
              minWidth: 52,
              minHeight: 44,
              fontWeight: lng === currentLang ? 700 : 400,
              color: lng === currentLang ? '#1E3A5F' : '#5F6B7A',
              backgroundColor: lng === currentLang ? '#E6E9EE' : 'transparent',
              borderRadius: '10px',
              fontSize: '14px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#F7F9FC',
                color: '#1E3A5F',
              },
            }}
          >
            {LANG_LABELS[lng]}
          </Button>
        ))}
      </Box>
    );
  }

  // Desktop: inline buttons in utility row
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, ml: 2 }}>
      {supportedLangs.map((lng, i) => (
        <React.Fragment key={lng}>
          {i > 0 && (
            <Box
              component="span"
              sx={{ color: '#E6E9EE', fontSize: '12px', mx: 0.25, userSelect: 'none' }}
            >
              |
            </Box>
          )}
          <Box
            component="button"
            onClick={() => switchLanguage(lng)}
            sx={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '2px 4px',
              fontWeight: lng === currentLang ? 700 : 400,
              color: lng === currentLang ? '#1E3A5F' : '#5F6B7A',
              fontSize: '12px',
              lineHeight: '16px',
              fontFamily: 'inherit',
              '&:hover': { color: '#1E3A5F' },
            }}
          >
            {LANG_LABELS[lng]}
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default LanguageSwitcher;
